import React, { useEffect, useState, useRef } from 'react';
import request from '../utils/request';
import { useWebSocket } from '../context/WebSocketContext';
import { useTheme } from '../context/ThemeContext';
import './AdminQueuePanel.css';

const API = 'https://server.battleverse.cn/admin/queue';
export default function AdminQueuePanel() {
  const { fightStatus, fightInfo } = useWebSocket();
  const { theme } = useTheme();
  const [snapshot, setSnapshot] = useState(null), [now, setNow] = useState(0);
  const [error, setError] = useState(''), [busy, setBusy] = useState(null), [confirm, setConfirm] = useState(null);
  const refreshRef = useRef(null);
  useEffect(() => {
    setSnapshot(null);setError('');setConfirm(null);
    if (fightStatus !== 20 && fightStatus !== 30) return;
    let stopped = false, timer;
    const refresh = async () => {
      try {
        const r = await request.post(`${API}/list.do`, {}, { timeout: 10000 });
        if (!stopped) { setSnapshot({ ...r.data, receivedAt: performance.now() });setError(''); }
      } catch (e) { if (!stopped) setError('列表暂时无法更新，请稍后重试'); }
    };
    refreshRef.current = refresh;
    const loop = async () => { await refresh();if (!stopped) timer = setTimeout(loop, 3000); };
    loop();const clock = setInterval(() => setNow(performance.now()), 500);
    return () => { stopped = true;clearTimeout(timer);clearInterval(clock);refreshRef.current = null; };
  }, [fightStatus, fightInfo?.id]);
  const act = async (item, action) => {
    if (busy) return;
    setBusy(item.ticketId);setError('');
    try {
      await request.post(`${API}/action.do`, { ticketId: item.ticketId, fightId: item.fightId, attentionDeadlineAt: item.attentionDeadlineAt, action }, { timeout: 10000 });
      setConfirm(null);
    } catch (e) { setError(e.response?.data?.msg || e.message || '操作未完成，请刷新确认'); }
    finally { setBusy(null);await refreshRef.current?.(); }
  };
  if (fightStatus !== 20 && fightStatus !== 30) return null;
  const items = snapshot?.items || [];
  return <section className="pb-admin-queue" aria-label="异常提交处理" style={{ '--aq-bg': theme.cardBg, '--aq-text': theme.text, '--aq-muted': theme.textSecondary, '--aq-border': theme.border, '--aq-accent': theme.tabActiveColor }}>
    <div className="pb-admin-queue-heading"><h3>异常提交 <span>{items.length}</span></h3><span>60 秒未重试自动取消</span></div>
    <p>重试上传时，参赛者需保持比赛页面打开。取消只影响该条未完成的提交。</p>
    {error && <p role="alert">{error}</p>}
    {!items.length && <p>{snapshot ? '当前没有需要人工处理的请求' : '正在读取请求'}</p>}
    <ul>{items.map(item => {
      const left = Math.max(0, Math.ceil((item.attentionRemainingMs - Math.max(0, now - snapshot.receivedAt)) / 1000));
      return <li key={item.ticketId}>
        <div className="pb-admin-queue-person"><span>{item.userName || `用户 ${item.userId}`}</span><small>#{item.userId} · {item.kind === 'upload' ? '上传' : '投票'}</small></div>
        <span className="pb-admin-queue-countdown">{left > 0 ? `${left} 秒后取消` : '正在确认取消'}</span>
        <div className="pb-admin-queue-buttons">
          {confirm === item.ticketId ? <><span>确认取消？</span><button disabled={!!busy || !left} onClick={() => act(item, 'cancel')}>确认</button><button onClick={() => setConfirm(null)}>返回</button></>
            : <><button disabled={!!busy || !left} onClick={() => act(item, 'retry')}>重试</button><button disabled={!!busy || !left} onClick={() => setConfirm(item.ticketId)}>取消</button></>}
        </div>
      </li>;
    })}</ul>
  </section>;
}
